//Auth user after login
export const authenticate = (response, next) => {
  localStorage.setItem("userId", response.data.user._id);
  localStorage.setItem("userName", response.data.user.name);
  localStorage.setItem("imageUrl", response.data.user.imageUrl);
  localStorage.setItem("token", response.data.token);
  localStorage.setItem("bio", response.data.user.bio);
  localStorage.setItem("phone", response.data.user.phone);
  localStorage.setItem("city", response.data.user.address.city);
  localStorage.setItem("country", response.data.user.address.country);
  next();
};
